module.exports = __webpack_public_path__ + "img/band.83102cfb.svg";